import { render, staticRenderFns } from "./deliverySetting.vue?vue&type=template&id=2e0f53ea&scoped=true"
import script from "./deliverySetting.vue?vue&type=script&lang=js"
export * from "./deliverySetting.vue?vue&type=script&lang=js"
import style0 from "./deliverySetting.vue?vue&type=style&index=0&id=2e0f53ea&lang=scss&scoped=true"
import style1 from "./deliverySetting.vue?vue&type=style&index=1&id=2e0f53ea&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f53ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0f53ea')) {
      api.createRecord('2e0f53ea', component.options)
    } else {
      api.reload('2e0f53ea', component.options)
    }
    module.hot.accept("./deliverySetting.vue?vue&type=template&id=2e0f53ea&scoped=true", function () {
      api.rerender('2e0f53ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/deliverySetting.vue"
export default component.exports